/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { useTheme } from '@mui/material/styles';
import { Box, Grid } from '@mui/material';


import { SimButton } from 'components/SimButton';
import { whyChooseUsReasons } from './data';
import SimSectionTitle from 'components/SimSectionTitle';
import { WhyChooseUsCard } from './WhyChooseUsCard';

const WhyChooseUs = () => {
	const theme = useTheme();
	return (
		<Box>
			<Box marginBottom={4}>
				<SimSectionTitle title='Why Choose Us?'>
					While many clinics are available, most are inherently focused on quick fixes instead of
					<br />
					taking a holistic approach towards the well being of a child. Simple Souls was found to do better.
				</SimSectionTitle>

				<Box marginTop={3} width={1} display={'flex'} justifyContent={'flex-end'}>
					<SimButton
						component={'a'}
						href={'./contact'}
						target={'_blank'}
						variant='contained'
						backgroundColor={theme.palette.background.btnPrimaryInfo}
						color={theme.palette.text.btnPrimaryInfo}
						size='large'>
						Learn About Us
					</SimButton>
				</Box>
			</Box>
			<Box>
				<Grid container spacing={4}>
					{whyChooseUsReasons.map((item, idx) => (
						<WhyChooseUsCard key={idx} item={item} idx={idx} />
					))}
				</Grid>
			</Box>
		</Box>
	);
};

export { WhyChooseUs };
